<!-- 奖励说明 -->
<template>
  <div class="reward-container">
    <GoldTitle
      context="icon12jianglishuoming"
    />
    <div
      class="reward-arrow"
      :class="{
        'adjust-height': isLevelPage
      }"
    >
      <img
        :src="rewardArrow"
        alt="rewardArrow"
      >
    </div>
    <div
      class="reward-table"
    >
      <div
        class="reward-col"
        style="width: 53px; flex: none"
      >
        <div class="reward-level-item reward-yellow"></div>
        <div
          v-for="item in headerList"
          :key="item.context"
          class="reward-item reward-yellow"
          :class="[isLevelPage ? 'adjust-height' : '']"
        >
            {{ item.context }}
        </div>
      </div>
      <div
        v-for="(item, index) in rewardData"
        :key="`${item.partnerLevel}_${index}`"
        class="reward-col"
      >
        <div
          v-show="isLevelPage && item.partnerLevel === currentLevel"
          class="current-pos"
        >
           {{ $t('app.label.currentPostion') }}
        </div>
        <div
          class="reward-level-item"
          :class="(index + 1) % 2 === 0 ? 'reward-purple' : 'reward-blue'"
          :style="`height:${30 + index * 12}px; font-size: ${index === 0 ? '27' : '30'}px`"
        >
          <svg
            class="icon"
            aria-hidden="true"
          >
            <use :xlink:href="`#iconLV${item.partnerLevel}`"></use>
          </svg>
        </div>
        <div
          v-for="col in headerList"
          :key="col.key"
          class="reward-item"
          :class="[(index + 1) % 2 === 0 ? 'reward-gray' : 'reward-white', isLevelPage ? 'adjust-height' : '']"
        >
            <span
              :class="{
                active: col.key === 'partnerCommission' && item[col.key] !== '/'
              }"
            >
              {{ item[col.key] ? item[col.key] : '/' }}
            </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoldTitle from '../goldTitle'
import rewardArrow from '@/assets/images/rewardArrow.png'
export default {
  name: 'reward-description',
  components: { GoldTitle },
  props: {
    currentLevel: {
      type: String,
      default: ''
    },
    rewardData: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    isLevelPage() {
      // 在当前等级页展示
      return this.$route.name === 'level'
    }
  },
  data() {
    return {
      rewardArrow,
      headerList: [
        {
          context: '累计有效客户数',
          key: 'numberRange'
        },
        {
          context: '累计入账流水',
          key: 'cumulativeEntry'
        },
        {
          context: '单客户入账奖励金额',
          key: 'singleCustomerReward'
        },
        {
          context: '入账流水提成',
          key: 'partnerCommission'
        }
      ],
      list: [
        {
          level: '1',
          numberRange: '1-10',
          cumulativeEntry: '100万元',
          singleCustomerReward: '￥ 200',
          partnerCommission: ''
        },
        {
          level: '2',
          numberRange: '1-10',
          cumulativeEntry: '100万元',
          singleCustomerReward: '￥ 200',
          partnerCommission: ''
        },
        {
          level: '3',
          numberRange: '1-10',
          cumulativeEntry: '100万元',
          singleCustomerReward: '￥ 200',
          partnerCommission: ''
        },
        {
          level: '4',
          numberRange: '1-10',
          cumulativeEntry: '100万元',
          singleCustomerReward: '￥ 200',
          partnerCommission: '0.01%'
        },
        {
          level: '5',
          numberRange: '1-10',
          cumulativeEntry: '100万元',
          singleCustomerReward: '￥ 200',
          partnerCommission: '0.02%'
        }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
  .reward-container {
    position: relative;
    background-color: #282830;
    border-radius:4px;
    padding-bottom: 33px;
  }
  .reward-arrow {
    width: 100%;
    height: 112px;
    display: flex;
    align-items: flex-end;
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    &.adjust-height {
      height: 132px;
    }
    img {
      width: 94%;
      position: relative;
      top: -10px;
    }
  }
  .current-pos {
    // width: 54px;
    // height: 54px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    border-radius: 50%;
    background-color: #ffdd3f;
    box-sizing: border-box;
    padding: 10px;
    line-height:16px;
    font-size:12px;
    color: #121212;
    margin-bottom: 12px;
    position: relative;
    z-index: 8;
    &::after {
      content: '';
      display: block;
      height: 0px;
      width: 0px;
      border-color: #fff  transparent transparent transparent;
      border-style: solid;
      border-width: 4px;
      position: absolute;
      left: 50%;
      transform: translate(-50%, 98%);
      bottom: 0;
      z-index: 10;
    }
  }
  .reward-table {
    display: flex;
    flex-direction: row;
    padding-top: 75px;
  }
  .reward-col {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    flex: 1;
    .reward-level-item {
      border-radius:8px 0px 0px 0px;
      height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 30px;
      // border-bottom: 1px solid rgba(221,221,221, 0.5);
    }
    .reward-item {
      display: flex;
      align-items: center;
      justify-content: center;
      color: rgba(255,255,255,0.86);
      line-height:16px;
      text-align: center;
      font-size: 11px;
      height: 54px;
      word-break: break-all;
      .active {
        font-size: 15px;
        font-weight: bold;
        color: #ffdd3f;
      }
      &.adjust-height {
        height: 66px;
      }
    }
  }
  .reward-yellow {
    color: #f7f7f7;
    background: #4a4d5d;
  }
  .reward-blue {
    color:rgba(255,254,255,1);
    background: linear-gradient(133deg,#85d784 22%, #00a0e9 84%);
  }
  .reward-purple {
    color: #fffeff;
    background: linear-gradient(134deg,#3023ae, #c86dd7 100%);
  }
  .reward-gray {
    background: #4A4D5D;
  }
  .reward-white {
    background: #555A72;
  }
</style>
